import PropTypes from 'prop-types';
import { FiDatabase, FiMonitor, FiServer } from 'react-icons/fi';

import TypographyWithIcon from '../common/TypographyWithIcon';

const renderIcon = (type) => {
    if (type === 'DEVICE') {
        return <FiMonitor />;
    } else if (type === 'DATABASE') {
        return <FiDatabase />;
    } else {
        return <FiServer />;
    }
};

const ContainerTitle = ({ type, name }) => {
    return (
        <TypographyWithIcon icon={renderIcon(type)} variant="h6" alignItems="center">
            {type !== 'DEVICE' ? name : 'GreenFrame browser'}
        </TypographyWithIcon>
    );
};

ContainerTitle.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string,
};

export default ContainerTitle;
